import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface SplitNumberInputWrapperProps {
  $disabled?: boolean
  $error?: boolean
}

const DROPDOWN_TRIGGER_MIN_WIDTH = '85px'

interface DropdownTriggerProps {
  $isOpen?: boolean
  $minWidth?: string
}

export const SplitNumberInputWrapper = styled.div<SplitNumberInputWrapperProps>`
  display: flex;
  align-items: center;
  border-radius: ${DefaultValue.BorderRadius};
  position: relative;
  background-color: ${({ $disabled }) => ($disabled ? Color.Grey100 : Color.White)};
  overflow: hidden;

  // We use pseudo-element to prevent layout shift when the border width changes on focus or hover
  &::after {
    content: '';
    box-sizing: border-box;
    border: ${({ $error }) => ($error ? `2px solid ${Color.Red700}` : `1px solid ${Color.Grey200}`)};
    border-radius: ${DefaultValue.BorderRadius};
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  &:hover::after {
    border-color: ${({ $disabled, $error }) => {
      if ($error) {
        return Color.Red700
      }
      if ($disabled) {
        return Color.Grey200
      }

      return Color.Black
    }};
  }

  &:focus-within::after {
    border: 2px solid ${({ $error }) => ($error ? Color.Red700 : Color.Lavender500)};
  }
`

export const InputSection = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

export const DropdownTrigger = styled.button<DropdownTriggerProps>`
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: ${Spacing.S14};
  justify-content: space-around;
  min-width: ${({ $minWidth = DROPDOWN_TRIGGER_MIN_WIDTH }) => $minWidth};
  padding: ${Spacing.S10} ${Spacing.S14};
  border: none;
  background-color: ${({ $isOpen }) => ($isOpen ? Color.Grey150 : 'transparent')};
  color: ${Color.Black};
  white-space: nowrap;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${Color.Grey100};
  }

  &:disabled {
    background-color: transparent;
    color: ${Color.Grey400};
    cursor: not-allowed;
  }
`
